// @flow

import gql from 'graphql-tag';

export default gql`
  fragment serviceCategories on Service {
    categories {
      id: slug
      name
      slug
    }
  }
`;
